export default __webpack_public_path__ + "static/media/linear1.3e2baaac.png";